module.exports = __webpack_public_path__ + "img/logo4.92509449.png";